import React from 'react';
import { useTheme } from '../contexts';
import MusicNoteIcon from './icons/MusicNoteIcon';

interface NoteToggleProps {
  showNotes: boolean;
  onToggleNotes: () => void;
}

const NoteToggle: React.FC<NoteToggleProps> = ({
  showNotes,
  onToggleNotes,
}) => {
  const { theme } = useTheme();

  return (
    <button
      onClick={onToggleNotes}
      className="note-toggle-button"
      style={{
        width: '32px', // Reduced from 38px to 32px for more compact look
        height: `${theme.spacing.xl - 4}px`, // 20px
        borderRadius: `${theme.radii.full}px`,
        padding: '2px',
        position: 'relative',
        backgroundColor: showNotes ? theme.colors.notes : theme.colors.textSecondary,
        border: 'none',
        cursor: 'pointer',
        transition: `all ${theme.motion.duration.fast}ms ${theme.motion.easing.standard}`,
      }}
    >
      <div
        style={{
          width: `${theme.spacing.lg}px`, // 16px
          height: `${theme.spacing.lg}px`, // 16px
          borderRadius: `${theme.radii.lg}px`,
          backgroundColor: theme.colors.background,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          left: showNotes ? 'calc(100% - 18px)' : '2px', // Adjusted for new 32px width
          top: '2px',
          transition: `all ${theme.motion.duration.fast}ms ${theme.motion.easing.standard}`,
        }}
      >
        <MusicNoteIcon
          size={10} // Could be theme.sizes.icon.xs if you add an xs size (10px)
          color={showNotes ? theme.colors.notes : theme.colors.textTertiary}
        />
      </div>
    </button>
  );
};

export default NoteToggle;
